import { useEffect, useState } from 'react'

/** 입력이 멈춘 뒤 delay(ms) 지나서 반영되는 값 — 검색어를 글자마다 서버에 보내지 않게. */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [v, setV] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setV(value), delay)
    return () => clearTimeout(t)
  }, [value, delay])
  return v
}

/** 긴 목록은 앞 step 줄만 그리고 '더 보기'로 늘린다(수천 줄 한 번에 그리면 화면이 버벅임).
 *  resetKey(검색어 등)가 바뀌면 다시 step 줄부터. */
export function useRenderLimit<T>(rows: T[], resetKey: unknown, step = 200) {
  const [limit, setLimit] = useState(step)
  useEffect(() => { setLimit(step) }, [resetKey, step])
  return {
    shown: rows.length > limit ? rows.slice(0, limit) : rows,
    hidden: Math.max(0, rows.length - limit),
    more: () => setLimit((n) => n + step),
    all: () => setLimit(Number.MAX_SAFE_INTEGER),
  }
}
